module.exports = __webpack_public_path__ + "static/media/au-glass.6198bbcf.png";